<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center" class="mt-4 ml-4">
        <v-col>
          <span class="text-h5 font-weight-bold" v-text="'Geolocations'"></span>
          <v-btn
            class="mx-2 mb-2"
            fab
            x-small
            color="primary"
            to="/geolocations/create"
          >
            <v-icon dark> mdi-plus </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6">
            <v-card-title>
              <v-row>
                <v-col sm="4">
                  <v-text-field
                    v-model="searchKeyword"
                    outlined
                    dense
                    label="Search by Location"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @input="getData"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-select
                    v-model="isActiveFilter"
                    :items="statusOptions"
                    outlined
                    dense
                    label="Filter by Status"
                    clearable
                    @change="getData"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-title>
            <v-progress-linear
              v-if="isLoading"
              indeterminate
              color="primary"
            ></v-progress-linear>
            <v-simple-table v-else fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Location</th>
                    <th class="text-left">Latitude</th>
                    <th class="text-left">Longitude</th>
                    <th class="text-left">Radius (m)</th>
                    <th class="text-left">Status</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody v-if="geolocations.length != 0">
                  <tr v-for="(geolocation, i) in geolocations" :key="`geolocation${i}`">
                    <td style="min-width: 85px">
                      {{ serialNoStarting + i + 1 }}
                    </td>
                    <td>{{ geolocation.location }}</td>
                    <td>{{ geolocation.latitude }}</td>
                    <td>{{ geolocation.longitude }}</td>
                    <td>{{ geolocation.radius || 200 }}</td>
                    <td>
                      <v-chip
                        small
                        :color="geolocation.is_active ? 'success' : 'error'"
                        text-color="white"
                      >
                        {{ geolocation.is_active ? 'Active' : 'Inactive' }}
                      </v-chip>
                    </td>
                    <td class="text-right">
                      <v-btn
                        class="mx-2"
                        fab
                        x-small
                        color="primary"
                        :to="`/geolocations/${geolocation.id}`"
                      >
                        <v-icon dark> mdi-pencil </v-icon>
                      </v-btn>
                      <v-btn
                        class="mx-2"
                        fab
                        x-small
                        color="error"
                        @click="deleteGeolocation(geolocation.id)"
                      >
                        <v-icon dark> mdi-delete </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="7" class="text-center">No data found</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-pagination v-model="page" :length="paginationLength" @input="getData">
            </v-pagination>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "GeolocationsPage",
  data() {
    return {
      page: 1,
      serialNoStarting: 0,
      paginationLength: 0,
      count: 0,
      isLoading: false,
      geolocations: [],
      searchKeyword: "",
      isActiveFilter: null,
      statusOptions: [
        { text: "Active", value: 1 },
        { text: "Inactive", value: 0 },
      ],
    };
  },

  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      try {
        let params = {
          page: this.page,
          rowsPerPage: this.rowsPerPage,
        };

        if (this.searchKeyword) {
          params.search_keyword = this.searchKeyword;
        }

        if (this.isActiveFilter !== null && this.isActiveFilter !== undefined) {
          params.is_active = this.isActiveFilter;
        }

        let response = await axios.get(`/geolocations`, { params });
        this.geolocations = response.data.data;
        this.count = response.data.count;
        this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
        this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
      } catch (error) {
        console.error("Error fetching geolocations:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async deleteGeolocation(id) {
      if (confirm("Are you sure you want to delete this geolocation?")) {
        try {
          this.isLoading = true;
          await axios.delete(`/geolocations/${id}`);
          this.getData();
        } catch (error) {
          console.error("Error deleting geolocation:", error);
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
